import { memo, useEffect } from "react";
import ChatBlock from "../ChatBlock";
import Heading from "../Heading";
import ConnectivityIssue from "../Layout/ConnectivityIssue";
// FIXME: Lazy load PoweredBy. By default it is not rendered, only render if user has not whitelabeledthe chatbot
import PoweredBy from "../PoweredBy";
import UserInputs from "../UserInputs";
import { useSelector } from "react-redux";
import { scrollMessageScreen } from "../../services/shared";
import ImagePreview from "../FlowComponents/ImagePreview";

const Chat = (props: { design: any, shouldFetchData?: boolean }) => {
  const environment = useSelector((state: any) => state?.environment);
  const { viewType } = environment;
  const {
    hideMessengerHeader,
    backgroundColor,
    landingPageChatBackgroundColor
  } = props.design || {};
  const isInIframe = window.self !== window.top;
  const hideHeader = viewType === 'landing-page' && hideMessengerHeader && isInIframe;
  const chatBackgroundColor =
    viewType === 'launcher-icon'
      ? backgroundColor
      : landingPageChatBackgroundColor || '#FFFFFF';

  const activeQuestion = environment?.activeQuestion;


  // the actual height container and what this functional returned
  useEffect(() => {
    scrollMessageScreen();
  }, [activeQuestion?.suggestions?.length]);

  return (
    <>
      <div className={`flex flex-col justify-between font-mRegular min-w-96 p-4 h-full`} style={{ backgroundColor: chatBackgroundColor }} id="chatWindow">
        {!hideHeader && <div id='ele-182' className="h-16 max-h-20 rounded-xl"><Heading /></div>}
        <div id="chat-block" className="h-full flex flex-col justify-between overflow-auto pb-2">
          <div className={`flex-grow`} id="message-container">
            <ChatBlock shouldFetchData={Boolean(props?.shouldFetchData)} />
          </div>
        </div>
        <div id='ele-303'><UserInputs showChatWindowOptions={hideHeader} /></div>
        <div id='ele-304' className="h-3 max-h-4 mt-2 text-sm text-center"><PoweredBy /></div>
        <div id='ele-305' className="position-fixed"> <ConnectivityIssue /> </div>
      </div>
      {
        environment.imagePreview && environment.imagePreview.isActive && environment.imagePreview.src && 
        <ImagePreview { ...environment.imagePreview } />
      }
    </>
  );
}

export default memo(Chat);

